import {Component} from '@angular/core';
import {ConfigureBaseComponent} from '../../configure-base/configure-base.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SelectOption} from '../../../../../../shared/interfaces/form';
import {WidgetUtils} from '../../widget-utils';
import {Observable} from 'rxjs';
import {dialogOpen} from '../../../../../../shared/store/dialog/dialog.actions';
import {ConfigureWidgetAxisChartComponent} from '../configure-widget-axis-chart.component';
import {
  selectDataSetMetricsGroupComponentObjects
} from '../../../../../../shared/store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {DatasetMetricsGroupComponentObjects} from '../../../../../../shared/classes/dataset-metrics-group-component-object';

@Component({
  selector: 'app-configure-widget-axis-chart-curve',
  templateUrl: './configure-widget-axis-chart-curve.component.html',
  styleUrls: ['./configure-widget-axis-chart-curve.component.scss']
})
export class ConfigureWidgetAxisChartCurveComponent extends ConfigureBaseComponent {
  public readonly categories$: Observable<DatasetMetricsGroupComponentObjects> = this._store.select(selectDataSetMetricsGroupComponentObjects);

  public form: FormGroup = new FormGroup({
    filters: new FormControl({}),
    metric: new FormControl(null, [Validators.required]),
    type: new FormControl(null, [Validators.required]),
    name: new FormControl(null, [Validators.required]),
  });

  public types: Array<any> = [
    { key: 'line', text: 'dashboard_report.line' },
    { key: 'bar',  text: 'dashboard_report.bar' },
    { key: 'area', text: 'dashboard_report.area' }
  ];

  ngOnInit(): void {
    super.ngOnInit();
  }

  public onClose(): void {
    this._store.dispatch(dialogOpen({
      component: ConfigureWidgetAxisChartComponent,
      config: {
        width: '750px',
        height: 'auto'
      },
      data: {
        mode: this.data.mode,
        widget: this.data.widget,
        dashboard: this.data.dashboard,
        curves: this.data.curves,
        form: this.data.form
      }
    }));
  }

  public onSubmit(): void {
    if (this.data.config) {
      this.data.curve.name =            this.form.get('name').value;
      this.data.curve.metric =          this.form.get('metric').value;
      this.data.curve.dimensions =      WidgetUtils.getFilterDimensions(this.form.get('filters').value, this.dimensions);
      this.data.curve.type =            this.form.get('type').value;
      this.data.curve.filters =         this.form.get('filters').value;
      this.data.curve.config.name =     this.form.get('name').value;
      this.data.curve.config.metrics =  [this.form.get('metric').value.payload.attributes.slug];
      this.data.curve.config.filters =  this.form.get('filters').value;
      this.data.curve.config.type =     this.form.get('type').value === 'area' && 'line' || this.form.get('type').value;
      this.data.curve.config.area =     this.form.get('type').value === 'area'
      this.data.curve.params = {
        dimensions: [],
        metrics: [this.form.get('metric').value]
      };
    } else {
      this.data.curves.push({
        name: this.form.get('name').value,
        dimensions: WidgetUtils.getFilterDimensions(this.form.get('filters').value, this.dimensions),
        metric: this.form.get('metric').value,
        type: this.form.get('type').value,
        filters: this.form.get('filters').value,
        params: {
          dimensions: [],
          metrics: [this.form.get('metric').value]
        }
      });
    }

    this.onClose();
  }

  public typeValueGetter(option: SelectOption<any, any>): string {
    return option.key;
  }

}
